import VueGtag from 'vue-gtag';

export default {
  name: 'vue_gtag',
  init: async ({ Vue, router }) => {
    Vue.use(VueGtag, { config: { id: process.env.VUE_APP_GOOGLE_ID } }, router);
  },
};
